import { useEffect, useState } from 'react'
import useAxios from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'
import { IUserLists } from '../../types/user'
import SelectSearch from '.'

interface Props {
  handleFilterChange?: (filter: any) => void
  users?: string[]
  onSelect: (e: any) => void
  resetAutoComplete?: string
  label?: string
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
}

const UserSelectSearch = (props: Props) => {
  const {
    handleFilterChange,
    users,
    onSelect,
    resetAutoComplete = '',
    label = 'เลือกผู้ใช้งาน',
    ...rest
  } = props
  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)

  const { data, isLoading } = useAxios<PaginationResponseInterface<IUserLists>>(
    {
      method: 'GET',
      url: '/users/merchant',
      params: {
        page: 1,
        perPage: 15,
        search: debouncedSearch,
        startDate: '',
        endDate: '',
      },
    },
  )

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  const handleSearch = async (value: string) => {
    setSearch(value)
  }

  const currentLoadingState = loading || isLoading

  return (
    <>
      <SelectSearch<IUserLists>
        {...rest}
        resetAutoComplete={resetAutoComplete}
        label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
        onSelect={onSelect}
        search={search}
        onSearch={handleSearch}
        options={
          data?.records.map(
            (user: IUserLists) =>
              user.isAvailable && {
                label: `${user.name} (${user.username})`,
                value: user,
              },
          ) || ([] as IOptionSelect<IUserLists>[])
        }
      />
    </>
  )
}

export default UserSelectSearch
